import React, { Component } from 'react';
import { Convert } from 'src/helpers';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import styles from './_mobileOneTimeTransactionsSuccess.module.scss';

class MobileOneTimeTransactionsSuccess extends Component {
  render() {
    const { checkoutDetail, status, reason, history } = this.props;
    const isSuccess = status === 'success';

    return (
      <div className={styles['mobile-sip-transactions']}>
        <div>
          <div className={styles['banner']}>
            <div className={styles['banner-inner']}>
              <div className={styles['banner-right']}>
                {isSuccess ? (
                  <div className={styles['banner-right-title']}>
                    We have received your lumpsum investment of
                    <div className={styles['banner-right-title-name']}>
                      {' '}
                      {Convert.toCurrencyValue(checkoutDetail?.oneClickCheckout?.amount || 0)}
                    </div>
                  </div>
                ) : (
                  <div>Payment failed</div>
                )}
              </div>
            </div>
          </div>

          <div className={styles['divider']} />

          <div
            className={cx(styles['green-check'], {
              [styles['failed-check']]: !isSuccess,
            })}
          >
            {isSuccess ? (
              <img src="/images/green-check.svg" alt="ok" />
            ) : (
              <img src="/images/failed.png" alt="failed" />
            )}
          </div>

          {isSuccess ? (
            <>
              <div className={styles['monthly-title']}>
                Units will be allocated to the{' '}
                <span> {checkoutDetail?.oneClickCheckout?.fundName} </span> within 2-3 working days
              </div>

              <div className={styles['monthly-title']}>
                Transaction ID: <span>{checkoutDetail?.oneClickCheckout?.depositRequestId}</span>
              </div>
            </>
          ) : (
            <div className={styles['monthly-title']}>{reason}</div>
          )}
        </div>
        <div className={styles['powered-by']}>powered by savvy</div>
        <div className={styles['footer-spacer']} />

        {!isSuccess && (
          <div
            className={cx(styles['footer'], {
              [styles['disabled-footer']]: false,
            })}
          >
            <button onClick={() => history.goBack()} disabled={false}>
              RETRY
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(MobileOneTimeTransactionsSuccess);
